<ul>
  @for (dataBlock of dataBlocks(); track $index) {
    @let animationDelay = $index * 100 + 'ms';
    @let gridColumn = dataBlock.size === 'small' ? null : 'span 2';
    @switch (dataBlock.type) {
      @case ('heartRate') {
        <li
          app-heart-rate-data-block-item
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
      @case ('heartRateZone') {
        <li
          app-heart-zone-rate-zone-data-block-item
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
      @case ('speed') {
        <li
          app-speed-data-block-item
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
      @case ('calories') {
        <li
          app-calories-data-item-block
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
      @case ('distance') {
        <li
          app-distance-data-item-block
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
      @case ('cadence') {
        <li
          app-default-data-item-block
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
          [unit]="cadenceUnitKey() | translate"
          icon="cadence"
        ></li>
      }
      @case ('power') {
        <li
          app-default-data-item-block
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
          icon="watts"
          unit="watts"
        ></li>
      }
      @case ('positiveSlope') {
        <li
          app-positive-slope-data-item-block
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
          icon="slope"
          label="d+"
        ></li>
      }
      @case ('duration') {
        <li
          app-duration-data-block-item
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
      @case ('pace') {
        <li
          app-pace-data-block-item
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
          icon="speed"
        ></li>
      }
      @case ('progress') {
        <li
          app-progress-data-block-item
          [class]="dataBlock.size"
          [style.grid-column]="gridColumn"
          [style.transition-delay]="animationDelay"
          [dataBlock]="dataBlock"
        ></li>
      }
    }
  }
</ul>
